import React from 'react';
//import MainForm from './components/MainForm_new';
//import MainForm from './components/MainForm_new_users';
import MainForm from './components/MainForm_new_users_wellaway';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
//import $ from 'jquery';
//import Popper from 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import './sonny.css';

import LanguageSelectorClass from './components/LanguageSelectorClassNew';
//import MetaDataClass from './components/Meta';
import MetaDataClass from './components/Meta_users_wellaway';

import TagManager from 'react-gtm-module';

function App() {

    const [hide, sethide] = React.useState('');

    const tagManagerArgs = {
        gtmId: 'GTM-5439NXD'
    }

   TagManager.initialize(tagManagerArgs)
    
    return (
        
        <React.Fragment>
            <MetaDataClass />
            <LanguageSelectorClass hide={hide} sethide={sethide}/>
            <section className={hide === '' ? 'question-first' : 'hidden'}>
                <div className="container">
                    <div className="row">
                       
                        <MainForm hide={hide}/>
                        </div>
                    </div>
                </section>
       </React.Fragment>         
       
    );
}

export default App;